import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface PontoGraficoModel {
    nome: string
    valor: number
    valorTotal: string
}

export interface CategoriaModel {
    id: number
    nome: string
}

export interface RespostaProdutosMaisVendidos {
    pontos: PontoGraficoModel[]
}

export interface FiltroMaisVendidos {
    dataInicio: string
    dataFim: string
    tipo: 1 | 2
    itemPesquisa?: string
    idCategoria?: number | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterProdutosMaisVendidos = async function (
    authorization: string,
    filtro: FiltroMaisVendidos
): Promise<RespostaProdutosMaisVendidos | ErroApi> {
    try {
        const params: Record<string, string> = {
            dataInicio: filtro.dataInicio,
            dataFim: filtro.dataFim,
            tipo: String(filtro.tipo),
        }
        if (filtro.itemPesquisa) params.itemPesquisa = filtro.itemPesquisa
        if (filtro.idCategoria != null) params.idCategoria = String(filtro.idCategoria)

        const response = await api
            .get<RespostaProdutosMaisVendidos | RespostaErroRaw>(
                "produto/ObterProdutosMaisVendidos",
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                    params,
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as RespostaProdutosMaisVendidos
    } catch (error) {
        RegistrarLogErro(error, "ObterProdutosMaisVendidos", JSON.stringify(filtro))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const obterCategoriasCardapio = async function (
    authorization: string
): Promise<CategoriaModel[] | ErroApi> {
    try {
        const response = await api
            .get<CategoriaModel[] | RespostaErroRaw>("produto/ObterCategoriasCardapio", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as CategoriaModel[]
    } catch (error) {
        RegistrarLogErro(error, "ObterCategoriasCardapio", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
